var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isLifetimeAndFeatureActive || !_vm.planInfo.isLifetime,
      expression: "isLifetimeAndFeatureActive || !planInfo.isLifetime"
    }],
    staticClass: "shadow-card border-radius-small",
    class: {
      clickable: !_vm.isDisabledPlan,
      'card-base-background': !_vm.planInfo.isLifetime,
      'card-base-background-lifetime': _vm.planInfo.isLifetime && _vm.isPreviewOnCheckout,
      'lifetime-card-background': _vm.planInfo.isLifetime && _vm.$breakpoint.tabletAndUp && !_vm.isPreviewOnCheckout,
      'lifetime-card-background-no-selected': _vm.planInfo.isLifetime && _vm.$breakpoint.mobileAndDown && !_vm.planInfo.isSelected && !_vm.isPreviewOnCheckout,
      'lifetime-card-background-mobile': _vm.planInfo.isLifetime && !_vm.$breakpoint.tabletAndUp && _vm.planInfo.isSelected && !_vm.isPreviewOnCheckout,
      'not-allowed': _vm.isDisabledPlan,
      'lifetime-card-title-border-radius': _vm.planInfo.isLifetime && !_vm.isPreviewOnCheckout,
      'mb-2': _vm.$vuetify.breakpoint.width < 375,
      'mb-4': _vm.$vuetify.breakpoint.width >= 375,
      'selected-card': !_vm.planInfo.isLifetime && _vm.planInfo.isSelected && !_vm.isPreviewOnCheckout,
      'selected-card-lifetime': _vm.planInfo.isLifetime && _vm.planInfo.isSelected && !_vm.isPreviewOnCheckout
    },
    attrs: {
      "no-gutters": ""
    },
    on: {
      "click": _vm.selectCard
    }
  }, [_vm.planInfo.isLifetime && !_vm.isPreviewOnCheckout ? _c('v-col', {
    staticClass: "col-12 text-center lifetime-card-title mb-2",
    class: {
      'lifetime-card-title-selected': _vm.planInfo.isSelected && !_vm.isPreviewOnCheckout
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.planInfo.saveMoneyTitle))])]) : _vm._e(), _c('v-row', {
    class: {
      'small-mobile-padding': _vm.$vuetify.breakpoint.width < 375,
      'pa-4': _vm.$vuetify.breakpoint.width >= 375
    }
  }, [_c('v-col', {
    staticClass: "text-left",
    class: {
      'col-8': _vm.$vuetify.breakpoint.smAndUp && !_vm.planInfo.isLifetime,
      'col-12': _vm.$vuetify.breakpoint.smAndUp && _vm.planInfo.isLifetime
    }
  }, [!_vm.planInfo.isLifetime ? _c('h4', {
    staticClass: "heading",
    class: {
      'text--darken-4 ': !_vm.isDisabledPlan,
      'text--lighten-1': _vm.isDisabledPlan,
      'heading-s-small mb-1': _vm.$vuetify.breakpoint.width < 375,
      'heading-m-small mb-2': _vm.$vuetify.breakpoint.width >= 375,
      'grey--text': !_vm.planInfo.isLifetime
    }
  }, [_vm._v(" " + _vm._s(_vm.planInfo.title) + " ")]) : _vm._e(), _vm.planInfo.isLifetime ? _c('v-row', {
    class: {
      'text--darken-4 ': !_vm.isDisabledPlan,
      'text--lighten-1': _vm.isDisabledPlan
    }
  }, [_c('v-col', {
    staticClass: "col-4 pt-5",
    attrs: {
      "align": "center"
    }
  }, [_c('v-row', {
    class: {
      'heading-s-small mb-1 pl-2': _vm.$vuetify.breakpoint.width < 375,
      'heading-m-small mb-2 pl-3': _vm.$vuetify.breakpoint.width >= 375
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "heading lifetime-text",
    class: {
      'white--text': !_vm.isPreviewOnCheckout
    }
  }, [_vm._v(" " + _vm._s(_vm.planInfo.title) + " ")])])], 1), _c('v-col', {
    staticClass: "col-8"
  }, [_c('v-row', {
    staticClass: "lifetime-prices",
    attrs: {
      "align": "center"
    }
  }, [!_vm.isPreviewOnCheckout ? _c('span', {
    staticClass: "lifetime-save-money-color"
  }, [_vm._v("$" + _vm._s(_vm.planInfo.saveMoney))]) : _vm._e(), _c('div', {
    staticClass: "heading",
    class: {
      'white--text': !_vm.isPreviewOnCheckout,
      'primary--text': _vm.isPreviewOnCheckout,
      'heading-m-small': _vm.$vuetify.breakpoint.width < 375 && !_vm.isPreviewOnCheckout,
      'heading-l-large': _vm.$vuetify.breakpoint.width >= 375 && !_vm.isPreviewOnCheckout,
      'heading-l-small': _vm.isPreviewOnCheckout,
      'mt-1': _vm.isPreviewOnCheckout
    }
  }, [_vm._v(" $" + _vm._s(new Intl.NumberFormat('en-IN', {
    maximumSignificantDigits: 3
  }).format(_vm.isLifetimePlan ? _vm.planInfo.priceWithDiscount : _vm.planInfo.price)) + " ")])])], 1)], 1) : _vm._e(), !_vm.planInfo.isPremium ? _c('p', {
    staticClass: "text text-l-small-regular mb-0 d-flex align-start",
    class: {
      'text--darken-4': !_vm.isDisabledPlan,
      'text--lighten-1': _vm.isDisabledPlan,
      'grey--text': !_vm.planInfo.isLifetime,
      'white--text': _vm.planInfo.isLifetime && !_vm.isPreviewOnCheckout
    }
  }, [_vm._v(" " + _vm._s(_vm.isPreviewOnCheckout && _vm.planInfo.isLifetime ? 'Unlimited access to CME and MOC credits.' : _vm.planInfo.description) + " ")]) : _vm._e(), _vm.planInfo.isPremium ? _c('p', {
    staticClass: "d-flex align-start text text-l-small-regular text-left mb-0",
    class: {
      'grey--text text--lighten-1': _vm.isDisabledPlan
    }
  }, [_vm._v(" " + _vm._s(_vm.planInfo.description) + " ")]) : _vm._e()], 1), !_vm.planInfo.isLifetime ? _c('v-col', {
    staticClass: "text-right",
    class: {
      'col-4': _vm.$vuetify.breakpoint.smAndUp,
      'col-auto': !_vm.$vuetify.breakpoint.smAndUp,
      'premium-prices': _vm.planInfo.isPremium
    }
  }, [_c('strong', {
    staticClass: "heading",
    class: {
      'primary--text': !_vm.isDisabledPlan,
      'grey--text text--lighten-1': _vm.isDisabledPlan,
      'heading-m-small': _vm.$vuetify.breakpoint.width < 375 && !_vm.isPreviewOnCheckout,
      'heading-l-large': _vm.$vuetify.breakpoint.width >= 375 && !_vm.isPreviewOnCheckout,
      'heading-l-small': _vm.isPreviewOnCheckout
    }
  }, [_vm._v("$" + _vm._s(_vm.showPerYear ? _vm.planInfo.price : _vm.planInfo.priceMonthly))]), _c('div', {
    staticClass: "text text-m-small-regular grey--text text--lighten-1"
  }, [_vm._v(" " + _vm._s(_vm.textToShowPerCycle) + " ")])]) : _vm._e(), _vm.$vuetify.breakpoint.xsOnly && _vm.planInfo.isSelected && !_vm.isPreviewOnCheckout ? _c('v-col', {
    staticClass: "mt-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.planInfo.yearCycle && !_vm.planInfo.isLifetime ? _c('div', {
    staticClass: "chip-billing-cycle text text-l-small-regular mb-4"
  }, [_vm._v(" " + _vm._s(_vm.planInfo.yearCycle) + " year subscription ")]) : _vm._e(), _c('ul', {
    staticClass: "list-style-none pl-0"
  }, [_vm._l(_vm.planInfo.benefits, function (benefit, index) {
    return _c('li', {
      key: index,
      staticClass: "text text-l-small-regular text--darken-4",
      class: {
        'mt-4': index > 0,
        'grey--text': !_vm.planInfo.isLifetime,
        'white--text': _vm.planInfo.isLifetime
      }
    }, [_c('ph-check', {
      staticClass: "mr-2",
      attrs: {
        "size": "24",
        "weight": "light",
        "color": "var(--v-secondary-base)"
      }
    }), _c('p', {
      staticClass: "mb-0",
      domProps: {
        "innerHTML": _vm._s(benefit)
      }
    })], 1);
  }), _vm._l(_vm.planInfo.limitations, function (limitation, index) {
    return _c('li', {
      key: index + _vm.uniqueKeysHelper(),
      staticClass: "text text-l-small-regular grey--text text--darken-4 mt-4"
    }, [_c('ph-x', {
      staticClass: "mr-2",
      attrs: {
        "size": "24",
        "weight": "light",
        "color": "var(--v-error-base)"
      }
    }), _c('p', {
      staticClass: "mb-0 text-decoration-line-through"
    }, [_vm._v(_vm._s(limitation))])], 1);
  })], 2)]) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }